// Scroll to Yotpo reviews section when clicking on star rating
(function() {
  const handledElements = new WeakSet();
  
  // Function to get header height (or use fixed offset)
  function getHeaderHeight() {
    const header = document.querySelector('header');
    if (header) {
      return header.offsetHeight;
    }
    return 60; // Default offset if header not found
  }
  
  // Function to scroll to reviews section
  function scrollToReviews() {
    const target = document.querySelector("#yotpo-reviews-main-widget");
    if (!target) return;

    const targetTop =
      target.getBoundingClientRect().top + window.scrollY - getHeaderHeight();

    window.scrollTo({
      top: targetTop,
      behavior: "smooth",
    });
  }

  // Function To Wait For Widget and Scroll
  function waitForWidgetAndScroll() {
    const widget = document.querySelector("#yotpo-reviews-main-widget");
    if (widget && widget instanceof HTMLElement && widget.offsetHeight > 50) {
      requestAnimationFrame(scrollToReviews);
      setTimeout(scrollToReviews, 500);
    } else {
      const observer = new MutationObserver(function() {
        const w = document.querySelector("#yotpo-reviews-main-widget");
        if (w && w instanceof HTMLElement && w.offsetHeight > 50) {
          observer.disconnect();
          requestAnimationFrame(scrollToReviews);
          setTimeout(scrollToReviews, 500);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  // Hash Scroll on Page Load
  if (window.location.hash === "#yotpo-reviews-main-widget") {
    waitForWidgetAndScroll();
  }

  // Click Scroll - Find all elements with IDs containing "yotpo_product_reviews_star_rating"
  function initYotpoScroll() {
    const starRatingElements = document.querySelectorAll('[id*="yotpo_product_reviews_star_rating"]');
    
    starRatingElements.forEach(function(element) {
      // Skip if already handled
      if (handledElements.has(element)) {
        return;
      }
      
      // Mark as handled
      handledElements.add(element);
      
      // Add click handler
      element.addEventListener('click', function(e) {
        waitForWidgetAndScroll();
      }, true); // Use capture phase to catch clicks early
      
      // Make it look clickable
      if (element instanceof HTMLElement) {
        element.style.cursor = 'pointer';
      }
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initYotpoScroll);
  } else {
    initYotpoScroll();
  }
  
  // Use MutationObserver to watch for dynamically added star rating elements
  const starRatingObserver = new MutationObserver(function(mutations) {
    initYotpoScroll();
    fixUncrawlableLinks();
  });
  
  starRatingObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Track fixed links to avoid duplicate handlers
  const fixedLinks = new WeakSet();
  
  // Function to fix uncrawlable links (javascript:void(0) -> proper URLs)
  function fixUncrawlableLinks() {
    // Find all links with javascript:void(0) that are related to reviews
    const uncrawlableLinks = document.querySelectorAll('a[href="javascript:void(0)"], a[href="javascript:void(0);"]');
    
    uncrawlableLinks.forEach(function(link) {
      // Skip if already fixed
      if (fixedLinks.has(link)) {
        return;
      }
      
      // Check if this is a reviews-related link (has aria-label with "reviews" or is in Yotpo widget)
      const ariaLabel = link.getAttribute('aria-label') || '';
      const isInYotpoWidget = link.closest('#yotpo-reviews-main-widget, [id*="yotpo"], .yotpo');
      
      if (ariaLabel.toLowerCase().includes('review') || isInYotpoWidget) {
        // Replace with hash link to reviews section
        link.setAttribute('href', '#yotpo-reviews-main-widget');
        
        // Mark as fixed
        fixedLinks.add(link);
        
        // Add click handler to scroll to reviews
        link.addEventListener('click', function(e) {
          e.preventDefault();
          waitForWidgetAndScroll();
        });
      }
    });
  }
  
  // Initialize link fixing
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixUncrawlableLinks);
  } else {
    fixUncrawlableLinks();
  }
  
  // Also fix links periodically as Yotpo loads content
  setTimeout(fixUncrawlableLinks, 1000);
  setTimeout(fixUncrawlableLinks, 3000);
})();

